import { LANGUAGES } from "../constants/language-constants";

export const DATETIME_FORMATS = {
  DDMMyyyy: "DD/MM/yyyy",
  DDMMMyyyyHHmmss: "DD MMM yyyy HH:mm:ss", // 28 Nov 2022 17:09:50
  DoMMMyyyyHHmmss: "Do MMMM yyyy", // 28 Nov 2022 17:09:50
  ddmmyy: "dd-mm-yy",
  MM_DD_YYYY: "MM-DD-yyyy", // moment utc 02-29-2022
  mm_dd_yyyy: "mm-dd-yy", // moment utc 02-29-2022
  dddd_DD_MMM_yyyy: "dddd, DD MMM yyyy",
  dddd_DD_MMM_yyyy_hhmmA: "dddd, DD MMM yyyy hh:mm A",
  DD_MMM_yyyy_hhmm: "DD MMM yyyy, HH:mm",
  DD_MM_YYYY: "DD-MM-yyyy", // moment utc 29-02-2022
  EEEE_dd_MMMM_y: "EEEE, dd MMMM y", // Tuesday, 01 August 2023
  EEEE_dd_MMMM_y_HHmmss: "EEEE, dd MMMM y HH:mm:ss", //Thứ Ba, 23 tháng 4 2024 07:59:06
  EEEE_dd_MMMM_y_HHmm: "EEEE, dd MMMM y HH:mm", //Thứ Ba, 23 tháng 4 2024 07:59
  dd_MMMM_y_HHmm: "dd MMMM y HH:mm", //23 tháng 4 2024 07:59,
  ddMMyyyy: "dd-MM-yyyy",
  dd_MM_yyyy: "dd/MM/yyyy", // 05/06/2024
  dddd_DD_MMM_yyyy_hhmmA2: "dddd, DD MMM yyyy hh:mm A", // thứ hai, 18 tháng 11 năm 2024 10:55
  hhmm_ddMMyyyy: "hh:mm DD/MM/yyyy",
  mmddyy: "mm/dd/yy",
  HH_mm: "HH:mm",
  DD_MM_YYYY_HH_MM: "DD/MM/yyyy HH:mm",
  dd_MM_yyyy_hh_mm_a: "dd/MM/yyyy hh:mm a",
  dd_mm_yy: "dd/mm/yy",
  YYYYMMDD: "YYYY/MM/DD",
  YYYY_MM_DD: "YYYY-MM-DD",
  DoMMMMMYYYY: "Do MMMM, YYYY",
  DDMMMYYYY: "DD MMM, YYYY",
  DDdotMMdotYYYY: "DD.MM.YYYY",
  YYYYdotMMdotDD: "YYYY.MM.DD",
}

export const MOMENT_LOCALES = {
  en: 'en',
  ko: 'ko',
  vi: 'vi',
};

export const LOCALE_DATE_FORMATS = {
  [LANGUAGES.VIETNAMESE]: {
    'DD MMM yyyy HH:mm:ss': 'DD MMM yyyy HH:mm:ss',
    'Do MMMM yyyy': 'Do MMMM yyyy',
    'dd-mm-yy': 'dd-MM-yy',
    'MM-DD-yyyy': 'dd-MM-yyyy',
    'MM/DD/yyyy': 'dd/MM/yyyy',
    'mm-dd-yy': 'dd-MM-yy',
    'dddd, DD MMM yyyy': 'dddd, DD MMM yyyy',
    'dddd, DD MMM yyyy hh:mm A': 'dddd, DD MMM yyyy hh:mm A',
    'DD MMM yyyy, HH:mm': 'DD MMM yyyy, HH:mm',
    'DD-MM-yyyy': 'DD-MM-yyyy',
    'EEEE, dd MMMM y': 'EEEE, dd MMMM y',
    'EEEE, dd MMMM y HH:mm:ss': 'EEEE, dd MMMM y HH:mm:ss',
    'EEEE, dd MMMM y HH:mm': 'EEEE, dd MMMM y HH:mm',
    'dd MMMM y HH:mm': 'dd MMMM y HH:mm',
    'yyyy MMM DD': 'yyyy MMM DD',
    'dd-MM-yyyy': 'dd-MM-yyyy',
    'dd/MM/yyyy': 'dd/MM/yyyy',
    'hh:mm DD/MM/yyyy': 'hh:mm DD/MM/yyyy',
    'DD/MM/yyyy': 'DD/MM/yyyy',
    'mm/dd/yy': 'dd/MM/yy',
    'HH:mm': 'HH:mm',
    'DD/MM/yyyy HH:mm': 'DD/MM/yyyy HH:mm',
    'dd/MM/yyyy hh:mm a': 'dd/MM/yyyy hh:mm a',
    'dd/mm/yy': 'dd/MM/yy',
    'D MMM, YYYY': 'D MMM, yyyy',
    'dddd, DD MMM yyyy HH:mm': 'dddd, DD MMM yyyy HH:mm',
    'YYYY-MM-DD': 'dd-MM-yyyy',
    'dd MMMM y': 'dd MMMM y',
    'HH:mm A': 'HH:mm A',
    'dddd': 'dddd',
    'A': 'A',
    'MMMM y': 'MMMM y',
    'dd MMMM y HH:mm a': 'dd MMMM y HH:mm a',
    'HH:mm a': 'HH:mm a',
    'dd MMMM y EEEE': 'dd MMMM y EEEE',
    'dddd, DD MMM yyyy HH:mm A': 'dddd, DD MMM yyyy HH:mm A',
    'y MMMM dd': 'y MMMM dd',
    'y.MM.DD HH:mm': 'DD.MM.yyyy HH:mm',
    'HH:mm, YYYY/MM/DD': 'HH:mm, yyyy/MM/dd',
    'dddd, DD/MM/yyyy HH:mm': 'dddd, DD/MM/yyyy HH:mm',
    'DD.MM.yyyy HH:mm': 'DD.MM.yyyy HH:mm',
    'DD MMM yyyy HH:mm': 'DD MMM yyyy HH:mm',
    'MM/dd/yyyy hh:mm:ss A': 'dd/MM/yyyy hh:mm:ss A',
    'DD.MM.YYYY': 'DD.MM.yyyy',
  },
  [LANGUAGES.ENGLISH]: {
    'DD MMM yyyy HH:mm:ss': 'MMM DD, yyyy HH:mm:ss',
    'Do MMMM yyyy': 'MMMM Do, yyyy',
    'dd-mm-yy': 'MM-dd-yy',
    'MM-DD-yyyy': 'MM-dd-yyyy',
    'MM/DD/yyyy': 'MM/dd/yyyy',
    'mm-dd-yy': 'MM-dd-yy',
    'dddd, DD MMM yyyy': 'dddd, MMM DD, yyyy',
    'dddd, DD MMM yyyy hh:mm A': 'dddd, MMM DD, yyyy hh:mm A',
    'DD MMM yyyy, HH:mm': 'MMM DD, yyyy, HH:mm',
    'DD-MM-yyyy': 'MM-DD-yyyy',
    'EEEE, dd MMMM y': 'EEEE, MMMM dd, y',
    'EEEE, dd MMMM y HH:mm:ss': 'EEEE, MMMM dd, y HH:mm:ss',
    'EEEE, dd MMMM y HH:mm': 'EEEE, MMMM dd, y HH:mm',
    'dd MMMM y HH:mm': 'MMMM dd, y HH:mm',
    'yyyy MMM DD': 'MMM DD, yyyy',
    'dd-MM-yyyy': 'MM-dd-yyyy',
    'dd/MM/yyyy': 'MM/dd/yyyy',
    'hh:mm DD/MM/yyyy': 'hh:mm MM/DD/yyyy',
    'DD/MM/yyyy': 'MM/DD/yyyy',
    'mm/dd/yy': 'MM/dd/yy',
    'HH:mm': 'HH:mm',
    'DD/MM/yyyy HH:mm': 'MM/DD/yyyy HH:mm',
    'dd/MM/yyyy hh:mm a': 'MM/dd/yyyy hh:mm a',
    'dd/mm/yy': 'MM/dd/yy',
    'D MMM, YYYY': 'MMM D, yyyy',
    'dddd, DD MMM yyyy HH:mm': 'dddd, MMM DD, yyyy HH:mm',
    'YYYY-MM-DD': 'MM-dd-yyyy',
    'dd MMMM y': 'MMMM dd, y',
    'HH:mm A': 'HH:mm A',
    'dddd': 'dddd',
    'A': 'A',
    'MMMM y': 'MMMM y',
    'dd MMMM y HH:mm a': 'MMMM dd, y HH:mm a',
    'HH:mm a': 'HH:mm a',
    'dd MMMM y EEEE': 'MMMM dd, y EEEE',
    'dddd, DD MMM yyyy HH:mm A': 'dddd, MMM DD, yyyy HH:mm A',
    'y MMMM dd': 'MMMM dd, y',
    'y.MM.DD HH:mm': 'MM.DD.yyyy HH:mm',
    'HH:mm, YYYY/MM/DD': 'HH:mm, yyyy/MM/dd',
    'dddd, DD/MM/yyyy HH:mm': 'dddd, MM/DD/yyyy HH:mm',
    'DD.MM.yyyy HH:mm': 'MM.DD.yyyy HH:mm',
    'DD MMM yyyy HH:mm': 'MMM DD, yyyy HH:mm',
    'MM/dd/yyyy hh:mm:ss A': 'MM/dd/yyyy hh:mm:ss A',
    'DD.MM.YYYY': 'MM.DD.yyyy',
  },
  [LANGUAGES.KOREAN]: {
    'DD MMM yyyy HH:mm:ss': 'yyyy MM DD HH:mm:ss',
    'Do MMMM yyyy': 'yyyy MMMM Do',
    'dd-mm-yy': 'yy-MM-dd',
    'MM-DD-yyyy': 'yyyy-MM-dd',
    'MM/DD/yyyy': 'yyyy/MM/dd',
    'mm-dd-yy': 'yy-MM-dd',
    'dddd, DD MMM yyyy': 'yyyy MMM DD dddd',
    'dddd, DD MMM yyyy hh:mm A': 'yyyy MMM DD dddd A hh:mm',
    'DD MMM yyyy, HH:mm': 'yyyy MM DD HH:mm',
    'DD-MM-yyyy': 'yyyy-MM-DD',
    'EEEE, dd MMMM y': 'y MMMM dd EEEE',
    'EEEE, dd MMMM y HH:mm:ss': 'y MMMM dd EEEE HH:mm:ss',
    'EEEE, dd MMMM y HH:mm': 'y MMMM dd EEEE HH:mm',
    'dd MMMM y HH:mm': 'y MMMM dd HH:mm',
    'yyyy MMM DD': 'yyyy MMM DD',
    'dd-MM-yyyy': 'yyyy-MM-dd',
    'dd/MM/yyyy': 'yyyy/MM/dd',
    'hh:mm DD/MM/yyyy': 'A hh:mm yyyy-MM-DD',
    'DD/MM/yyyy': 'yyyy/MM/DD',
    'mm/dd/yy': 'yy/MM/dd',
    'HH:mm': 'HH:mm',
    'DD/MM/yyyy HH:mm': 'yyyy/MM/DD HH:mm',
    'dd/MM/yyyy hh:mm a': 'yyyy/MM/dd A hh:mm',
    'dd/mm/yy': 'yy/MM/dd',
    'D MMM, YYYY': 'yyyy MMM D',
    'dddd, DD MMM yyyy HH:mm': 'yyyy MMM DD dddd HH:mm',
    'YYYY-MM-DD': 'yyyy-MM-dd',
    'dd MMMM y': 'y MMMM dd',
    'HH:mm A': 'A HH:mm',
    'dddd': 'dddd',
    'A': 'A',
    'MMMM y': 'y MMMM',
    'dd MMMM y HH:mm a': 'y MMMM dd A HH:mm',
    'HH:mm a': 'A HH:mm',
    'dd MMMM y EEEE': 'y MMMM dd EEEE',
    'dddd, DD MMM yyyy HH:mm A': 'yyyy MMM DD dddd A HH:mm',
    'y MMMM dd': 'y MMMM dd',
    'y.MM.DD HH:mm': 'yyyy.MM.DD HH:mm',
    'HH:mm, YYYY/MM/DD': 'A HH:mm, yyyy/MM/dd',
    'dddd, DD/MM/yyyy HH:mm': 'yyyy/MM/DD dddd HH:mm',
    'DD.MM.yyyy HH:mm': 'yyyy.MM.DD HH:mm',
    'DD MMM yyyy HH:mm': 'yyyy MM DD HH:mm',
    'MM/dd/yyyy hh:mm:ss A': 'A hh:mm:ss yyyy/MM/dd',
    'DD.MM.YYYY': 'yyyy.MM.DD',
  },
};

export const MONTHS_NAME = [
  "CALENDAR.MONTH_NAMES.JANUARY",
  "CALENDAR.MONTH_NAMES.FEBRUARY",
  "CALENDAR.MONTH_NAMES.MARCH",
  "CALENDAR.MONTH_NAMES.APRIL",
  "CALENDAR.MONTH_NAMES.MAY",
  "CALENDAR.MONTH_NAMES.JUNE",
  "CALENDAR.MONTH_NAMES.JULY",
  "CALENDAR.MONTH_NAMES.AUGUST",
  "CALENDAR.MONTH_NAMES.SEPTEMBER",
  "CALENDAR.MONTH_NAMES.OCTOBER",
  "CALENDAR.MONTH_NAMES.NOVEMBER",
  "CALENDAR.MONTH_NAMES.DECEMBER",
];